var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouseholdDevices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      color: "white"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.98871 11.4H6.11371C5.07573 11.3998 4.08035 10.9873 3.34639 10.2534C2.61243 9.5194 2.19997 8.52402 2.19971 7.48605V5.06604H10.8997V7.48605C10.8997 8.52358 10.4878 9.51867 9.75439 10.2526C9.02103 10.9865 8.02625 11.3992 6.98871 11.4V11.4Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.68395 1.09998H4.52495C4.43163 1.09998 4.33921 1.11837 4.25301 1.15411C4.1668 1.18986 4.0885 1.24225 4.02255 1.30828C3.95661 1.37432 3.90434 1.45271 3.86871 1.53896C3.83309 1.62522 3.81481 1.71765 3.81494 1.81097V5.08398H5.39395V1.81097C5.39395 1.62258 5.31917 1.44188 5.18605 1.30857C5.05293 1.17526 4.87234 1.10024 4.68395 1.09998V1.09998Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61461 1.09998H8.45561C8.36229 1.09998 8.26988 1.11837 8.18367 1.15411C8.09746 1.18986 8.01914 1.24225 7.9532 1.30828C7.88726 1.37432 7.83498 1.45271 7.79936 1.53896C7.76374 1.62522 7.74547 1.71765 7.74561 1.81097V5.08398H9.32361V1.81097C9.32361 1.62275 9.24898 1.44221 9.11607 1.30893C8.98317 1.17565 8.80283 1.10051 8.61461 1.09998V1.09998Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11549 11.111V12.411C8.11549 12.5618 8.0557 12.7063 7.9492 12.813C7.84271 12.9197 7.69824 12.9798 7.5475 12.98H5.5265C5.37577 12.9798 5.23129 12.9197 5.1248 12.813C5.01831 12.7063 4.9585 12.5618 4.9585 12.411V11.098",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6696 12.975H13.4516C12.9316 12.9752 12.433 13.1819 12.0653 13.5496C11.6976 13.9173 11.4909 14.416 11.4906 14.936C11.4904 15.1943 11.4391 15.4501 11.3398 15.6887C11.2405 15.9272 11.095 16.1437 10.9118 16.3259C10.7286 16.5081 10.5112 16.6523 10.2722 16.7503C10.0331 16.8483 9.77702 16.8982 9.51865 16.897L8.48865 16.889C7.96968 16.8866 7.4728 16.6787 7.10677 16.3108C6.74074 15.9429 6.53537 15.4449 6.53564 14.926V12.975",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseholdDevices);
export default __webpack_public_path__ + "static/media/household-devices.81bb55187827cc5dab52b26baca52eba.svg";
export { ForwardRef as ReactComponent };